import { isArray, isObject, isTypeof } from "./is.js";
//#region src/utils/deepEqual.ts
function deepEqual(a, b) {
	if (a === b) return true;
	if (isTypeof(a, "number") && isNaN(a)) return isTypeof(b, "number") && isNaN(b);
	const aIsArray = isArray(a);
	const bIsArray = isArray(b);
	if (aIsArray !== bIsArray) return false;
	if (aIsArray && bIsArray) {
		const length = a.length;
		if (length !== b.length) return false;
		for (let idx = length; idx-- !== 0;) if (!deepEqual(a[idx], b[idx])) return false;
		return true;
	}
	const aIsObject = isObject(a);
	const bIsObject = isObject(b);
	if (aIsObject !== bIsObject) return false;
	if (a && b && aIsObject && bIsObject) {
		const aKeys = Object.keys(a);
		const bKeys = Object.keys(b);
		if (aKeys.length !== bKeys.length) return false;
		for (let aKey of aKeys) if (!bKeys.includes(aKey)) return false;
		for (let aKey of aKeys) if (!deepEqual(a[aKey], b[aKey])) return false;
		return true;
	}
	return false;
}
//#endregion
export { deepEqual };

//# sourceMappingURL=deepEqual.js.map